import React from 'react';
import Link from '../common/TrackedLink';
import { branch } from 'baobab-react/higher-order';
import CompareColumn from './CompareColumn';

const ProductCompare = ({ products, searchUrl}) => {
	const compareColumns = products.map(
		(product,index) => {
			let html;
			if (index < 4) {
				html = <CompareColumn key={ index } product={ product } />;
			}
			return html;
		}
	);
	const previousUrl = searchUrl ? searchUrl : '/products';
	return (
		<section className="section section-product-compare">
			<div className="section-content row">
				<div className="col">
					<h1>Safe Comparison</h1>
					<span><b>Bolded</b> product information below indicates the unique differences among the products being compared.</span><br></br>
					<Link className="arrow-link arrow-link-left" to={previousUrl}>
						Back to Products
					</Link>
					<div className="compare-columns row">
						{ compareColumns }
					</div>
				</div>
			</div>
		</section>
	);
};

export default branch({
	products: ['productsToCompare'],
	searchUrl: ['searchUrl']
}, ProductCompare);


// WEBPACK FOOTER //
// ./src/pages/productCompare/Index.js